<template>
  <div class="unavailable-assessment__backdrop">
    <section ref="dialog" class="unavailable-assessment"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="unavailable-assessment-message"
      aria-describedby="unavailable-assessment-details"
      tabindex="-1"
      @keydown.esc.stop="$emit('close')">
        <button class="unavailable-assessment__close"
          type="button"
          :aria-label="$t('app.assessment_unavailable.close')"
          @click="$emit('close')">
          <v-icon class="unavailable-assessment__close-icon" size="28">{{ icons.mdiClose }}</v-icon>
        </button>
      <div class="unavailable-assessment__icon" aria-hidden="true">
        <v-icon class="unavailable-assessment__alert-icon" size="26">{{ icons.mdiAlertOutline }}</v-icon>
      </div>
      <p id="unavailable-assessment-message">{{ message }}</p>
      <div v-if="patientGroups.length" class="unavailable-assessment__groups">
        <strong>{{ $t('app.assessment_unavailable.patient_groups') }}</strong>
        <p>{{ patientGroups.join(' · ') }}</p>
      </div>
      <p id="unavailable-assessment-details">{{ $t('app.assessment_unavailable.check_details') }}</p>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'
import icons from '@/mixins/icons'
import { useDialogFocusTrap } from '@/composables/useDialogFocusTrap'

export default defineComponent({
  name: 'UnavailableAssessmentDialog',
  mixins: [icons],
  props: {
    message: { type: String, required: true },
    patientGroups: { type: Array as PropType<string[]>, default: () => [] },
  },
emits: ['close'],
  setup() {
    const dialog = ref<HTMLElement | null>(null)
    useDialogFocusTrap(dialog)
    return { dialog }
  },
})
</script>

<style scoped src="../styles/unavailable-assessment-dialog.css"></style>
